import { render, staticRenderFns } from "./ItemDetails.vue?vue&type=template&id=3526b6d0&scoped=true"
import script from "./ItemDetails.vue?vue&type=script&lang=ts"
export * from "./ItemDetails.vue?vue&type=script&lang=ts"
import style0 from "./ItemDetails.vue?vue&type=style&index=0&id=3526b6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3526b6d0",
  null
  
)

export default component.exports